/** @jsx jsx */
import { Fragment } from 'react'
import styled from '@emotion/styled'
import { jsx, Button, Flex, Box, Heading } from 'theme-ui'
import ContentfulRichText from '../shared/Contentful/RichText'
import { BLOCKS } from '@contentful/rich-text-types'
import Body from '../shared/Typography/Body/Body'
import Slider from 'react-slick'
import CustomStarRating from '../shared/StarRating/StarRating'
import { useWindowSize } from '../../hooks/useWindowSize'

const ReviewCarousel = props => {
  const { mobile } = useWindowSize()

  const textColor = (props.theme && props.theme.textColor) || 'white'
  const isInline = props.layoutVariation === 'inline'
  const options = {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <Body
        variant="textSection"
        sx={{ color: textColor, fontSize: isInline && [1, 1, 1] }}
      >
        {children}
      </Body>
    ),
  }

  return (
    <Flex
      sx={{
        width: ['100%'],
        p: 25,
        bg: 'black',
        minHeight: isInline ? 'auto' : '60vh',
        justifyContent: 'center',
        alignItems: 'center',
        bg: (props.theme && props.theme.backgroundColor) || 'black',
      }}
    >
      <Box>
        <Slider
          prevArrow={<Fragment />}
          nextArrow={<Fragment />}
          slidesToShow={isInline && !mobile ? 3 : 1}
          swipeToSlide={false}
          initialSlide={0}
          autoplay={true}
          autoplaySpeed={4000}
          infinite={true}
          dots={true}
          swipe={false}
          {...props}
        >
          {props.reviews.map((i, k) => (
            <Flex
              key={k}
              sx={{
                justifyContent: 'center',
                textAlign: 'center',

                marginBottom: '55px',
                outline: '0px !important',
                color: textColor,
              }}
            >
              <CustomStarRating rating={5} starRatedColor={textColor} />
              <Heading
                as={isInline ? 'h6' : 'h5'}
                variant="bold"
                sx={{ color: textColor, marginTop: '20px' }}
              >
                {i.title}
              </Heading>
              <ContentfulRichText text={i.text} customOptions={options} />
            </Flex>
          ))}
        </Slider>
      </Box>
    </Flex>
  )
}

export default ReviewCarousel
